/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Indicator/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconTeeth from 'DesignSystem/Svgs/TysiaIconTeeth/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Indicator({
  children,
  viewPath = "/DesignSystem/TimelineEvent/CustomResource/Content/Content/Indicator"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Indicator.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Indicator.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-1wiWS0': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
/>
<div
  data-testid="Indicator.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaTagIcon
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<TysiaIconTeeth
{...childProps}
  viewPath={`${viewPath}/TysiaIconTeeth`}
 height={32}
 width={32}
/>
)}
</TysiaTagIcon>
</div>
</div>
{children}
</React.Fragment>)
}